import React from 'react';

const BranchSwitch = props => {
    const {
        branches,
        setCurrentBranch
    } = props;

    return (
        <div className="radiogroup">
            {
                branches.map(branch => {
                    return (
                        <div className="radio" key={branch.id}>
                            <input
                                className="radio_input"
                                type="radio"
                                name="branchswitch"
                                id={branch.id}
                                value={branch.id}
                                onChange={() => { setCurrentBranch(branch.id); }}
                                checked={branch.isActive}
                                />
                            <label
                                className="label radio_label"
                                htmlFor={branch.id}>
                                {branch.i18n}        
                            </label>   
                        </div>
                    )
                })
            }
        </div>
    )
};

export default BranchSwitch;